import LZUTF8 from "lzutf8";

export const decompressData = dataString =>
  LZUTF8.decompress(dataString, { inputEncoding: "Base64" });

export const compressData = dataString =>
  LZUTF8.compress(dataString, { outputEncoding: "Base64" });
